<div class="premium-modal-wrapper">
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="close()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main" *ngIf="trabajo">{{trabajo.lugar}}</div>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="premium-content-bg ion-padding content-bg">

    <!-- Top Actions: Edit & Cotización & Delete -->
    <div class="top-actions">
      <div class="premium-card action-card edit" (click)="edit()"
        style="justify-content: center; flex-direction: column; gap: 6px; padding: 12px 8px;">
        <ion-icon name="create-outline" style="font-size: 1.4rem;"></ion-icon>
        <span style="font-size: 0.8rem;">Editar</span>
      </div>

      <div class="premium-card action-card cotiz"
        (click)="permissions?.trabajos?.rl_editar_cotizacion !== false ? openCotizacion() : null"
        [class.read-only]="permissions?.trabajos?.rl_editar_cotizacion === false"
        style="justify-content: center; flex-direction: column; gap: 6px; padding: 12px 0px; position: relative;">
        <ion-icon name="document-text-outline" style="font-size: 1.4rem;"></ion-icon>
        <span style="font-size: 0.75rem; font-weight: 600;">Cotización</span>
        <span style="font-size: 0.75rem; color: #b2bec3;" *ngIf="cotizacionInfo">#{{cotizacionInfo.id}}</span>
        <span style="font-size: 0.7rem; color: #b2bec3; font-style: italic;"
          *ngIf="!cotizacionInfo && !loadingCotizacion">N/A</span>
        <span style="font-size: 0.7rem; color: #b2bec3; font-style: italic;" *ngIf="loadingCotizacion">...</span>

        <!-- Botón de desvincular -->
        <div class="remove-mini-btn" (click)="unlinkCotizacion(); $event.stopPropagation()"
          *ngIf="cotizacionInfo && !loadingCotizacion && permissions?.trabajos?.rl_editar_cotizacion !== false">
          <ion-icon name="unlink-outline" *ngIf="!isUnlinking"></ion-icon>
          <ion-spinner name="crescent" *ngIf="isUnlinking"></ion-spinner>
        </div>

        <!-- Botón de añadir/vincular -->
        <div class="add-mini-btn" (click)="addCotizacionFromMenu(); $event.stopPropagation()"
          *ngIf="!cotizacionInfo && !loadingCotizacion && permissions?.trabajos?.rl_editar_cotizacion === true">
          <ion-icon name="add"></ion-icon>
        </div>
      </div>

      <div class="premium-card action-card delete" 
        (click)="permissions?.trabajos?.rl_eliminar_trabajo === true ? confirmDelete() : null"
        [class.read-only]="permissions?.trabajos?.rl_eliminar_trabajo !== true"
        style="justify-content: center; flex-direction: column; gap: 6px; padding: 12px 8px;">
        <ion-icon name="trash-outline" style="font-size: 1.4rem;"></ion-icon>
        <span style="font-size: 0.8rem;">Eliminar</span>
      </div>
    </div>

    <!-- Circular Quick Actions -->
    <div class="section-label">Acciones rápidas</div>
    <div class="quick-actions">
      <div class="circle-action" (click)="openComments()">
        <div class="circle-icon comments">
          <ion-icon name="chatbubbles-outline"></ion-icon>
        </div>
        <span class="circle-label">Comentarios</span>
      </div>
      <div class="circle-action" (click)="openInfo()">
        <div class="circle-icon info">
          <ion-icon name="information-circle-outline"></ion-icon>
        </div>
        <span class="circle-label">Información</span>
      </div>
      <div class="circle-action" (click)="openReportes()" *ngIf="isArsEnabled">
        <div class="circle-icon reports">
          <ion-icon name="document-attach-outline"></ion-icon>
        </div>
        <span class="circle-label">Reportes (ARS)</span>
      </div>
      <div class="circle-action" (click)="openSeguimiento()">
        <div class="circle-icon history">
          <ion-icon name="time-outline"></ion-icon>
        </div>
        <span class="circle-label">Seguimiento</span>
      </div>
      <div class="circle-action" (click)="(isArsUploaded && cotizacionInfo) ? openEnviarArs() : null" *ngIf="trabajo?.cliente === 'Inmobiliaria Don Antonio' && permissions?.trabajos?.rl_enviar_ars === true" [class.disabled]="!isArsUploaded || !cotizacionInfo">
        <div class="circle-icon send-ars" [style.opacity]="(isArsUploaded && cotizacionInfo) ? '1' : '0.4'" style="background: rgba(155, 89, 182, 0.12);">
          <ion-icon name="mail-unread-outline" style="color: #9b59b6;"></ion-icon>
        </div>
        <span class="circle-label" [style.opacity]="(isArsUploaded && cotizacionInfo) ? '1' : '0.5'">Enviar ARS</span>
      </div>
      <div class="circle-action" (click)="openEnviarSolicitud()" *ngIf="permissions?.trabajos?.rl_enviar_solicitud === true">
        <div class="circle-icon send-solicitud">
          <ion-icon name="send-outline"></ion-icon>
        </div>
        <span class="circle-label">Enviar Solicitud</span>
      </div>
    </div>

    <!-- Main 2-column Cards Grid -->
    <div class="cards-container">

      <!-- Planilla Card -->
      <div class="premium-card menu-card planilla" (click)="openPlanilla()">
        <div class="card-icon">
          <ion-icon name="people-outline"></ion-icon>
        </div>
        <div class="card-label">Planilla</div>
        <div class="card-total" *ngIf="planillaTotalAmount !== null">
          ${{planillaTotalAmount | number:'1.2-2'}}
        </div>
        <div class="card-total loading" *ngIf="planillaTotalAmount === null">...</div>
        <div class="add-btn" (click)="addPlanilla(); $event.stopPropagation()">
          <ion-icon name="add"></ion-icon>
        </div>
      </div>

      <!-- Gastos Card -->
      <div class="premium-card menu-card gastos" (click)="openGastos()">
        <div class="card-icon">
          <ion-icon name="cash-outline"></ion-icon>
        </div>
        <div class="card-label">Gastos</div>
        <div class="card-total" *ngIf="gastosTotalAmount !== null">
          ${{gastosTotalAmount | number:'1.2-2'}}
        </div>
        <div class="card-total loading" *ngIf="gastosTotalAmount === null">...</div>
        <div class="add-btn" (click)="addGastos(); $event.stopPropagation()">
          <ion-icon name="add"></ion-icon>
        </div>
      </div>

      <!-- Galerias Card -->
      <div class="premium-card menu-card galerias" (click)="openGalerias()">
        <div class="card-icon">
          <ion-icon name="images-outline"></ion-icon>
        </div>
        <div class="card-label">Galerías</div>
        <div class="card-total" *ngIf="galleryCount > 0" style="font-size: 0.8rem;">
          {{ galleryCount }} {{ galleryCount === 1 ? 'Foto' : 'Fotos' }}
        </div>
        <div class="card-total empty" *ngIf="galleryCount === 0" style="font-size: 0.8rem; color: #b2bec3;">
          Vacío
        </div>
        <div class="add-btn" (click)="addGalerias(); $event.stopPropagation()">
          <ion-icon name="add"></ion-icon>
        </div>
      </div>

    </div>

  </ion-content>
</div>